export enum ErrorOrigin {
  BROWSER_EXTENSION = 'browser_extension',
  MICRO_FRONTEND = 'mfe',
  UNKNOWN = 'unknown',
}

export type ErrorContext = {
  error_origin?: ErrorOrigin;
  mfe?: string;
  version?: string;
};
